/**
 * GraphQL mutation for updating an ABR filter (full replacement).
 */

import { gql } from '@apollo/client';

export const UPDATE_ABR_FILTER = gql`
  mutation UpdateAbrFilter($input: UpdateAbrFilterInput!) {
    updateAbrFilter(input: $input) {
      id
      communityId
      name
      description
      criteria {
        reportedContent
        textLabelFilters {
          labelId
          contentType
          minSeverity
          minScore
        }
        textLabelFilterModifier
        imageLabelFilters {
          labelId
          contentType
          minSeverity
          minScore
        }
        imageLabelFilterModifier
      }
      createdAt
      createdBy
    }
  }
`;
